import * as classnames from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { ProductImages } from 'elc-images';
import { IAsset } from '../../domain/entities/Asset';
import { breakpoint } from 'elc-base-theme';

interface IProductZoomSlideItem {
    className?: string;
    image: IAsset;
    index: number;
    isThumb: boolean;
    onClick?(index: number): void;
}

export const SliderItemThumbWrapper = styled.div`
    cursor: pointer;
    height: 18vh;
    margin: 1vh auto;
    outline: 0;

    & > div {
        justify-content: center;
        align-items: center;
        display: flex;
    }

    img {
        cursor: pointer;
        height: auto;
        max-height: 100%;
        max-width: 90%;
        width: auto;
    }

    &.current {
        cursor: default;

        img {
            cursor: default;
        }
    }
`;

export const SliderItemFullWrapper = styled.div`
    height: 92vh;
    width: 100%;
    ${breakpoint('desktop')`
        max-width: 60vw;
    `};
`;

export class ProductZoomSlideItem extends React.Component<IProductZoomSlideItem> {
    private onClick = () => {
        const { index, onClick } = this.props;

        if (onClick) {
            onClick(index);
        }
    };

    public render() {
        const { className, isThumb, image } = this.props;
        const baseClassName = isThumb
            ? ['elc-product-zoom-item-thumb', 'js-product-zoom-item-thumb']
            : ['elc-product-zoom-item-full', 'js-product-zoom-item-full'];
        const wrapperClassName = classnames(...baseClassName, className);
        const Wrapper = isThumb ? SliderItemThumbWrapper : SliderItemFullWrapper;

        return (
            <Wrapper className={wrapperClassName} onClick={this.onClick}>
                <ProductImages imgPath={image.src} altText={image.alt} />
            </Wrapper>
        );
    }
}
